import { render, staticRenderFns } from "./TagPage.vue?vue&type=template&id=4c0196e8&scoped=true&"
import script from "./TagPage.vue?vue&type=script&lang=js&"
export * from "./TagPage.vue?vue&type=script&lang=js&"
import style0 from "./TagPage.vue?vue&type=style&index=0&id=4c0196e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0196e8",
  null
  
)

export default component.exports